import Styles from './ConfigureCreateAccessesAutomationModal.module.scss'
import { ConfigureCreateAccessesAutomationModalProps } from './Types'
import { useSourceData } from 'components/ReviewsWizard/SourceDataProvider/useSourceData'
import { SharedRecipientSelector } from 'components/ShareSheet/RecipientSelector/SharedRecipientSelector'
import { useRef, useState } from 'react'
import { Value } from 'components/ShareSheet/RecipientSelector/Types'
import { PermissionSelect } from 'components/PermissionSelect/PermissionSelect'
import { Permission } from 'types'
import { DehydratedChannel, DehydratedEmail, DehydratedUser, useHydrateInvites } from 'hooks/useHydrateInvites'
import { dehydrateInvites } from 'components/ShareSheet/RecipientSelector/dehydrateInvites'
import { MessageField } from 'components/MessageField/MessageField'
import { Modal } from 'almanac-ui/Modal'

const ConfigureCreateAccessesAutomationModal = ({
  onConfirm,
  onClose,
  ...config
}: ConfigureCreateAccessesAutomationModalProps) => {
  const sourceData = useSourceData({})
  const [recipients, setRecipients] = useState<Value[]>([])
  const [permission, setPermission] = useState<Permission>((config.permission || 'edit') as Permission)
  const [htmlMessage, setHtmlMessage] = useState(config.html_message || '')
  const inputRef = useRef<HTMLInputElement>()
  const { users = [], emails = [], channels = [] } = config

  useHydrateInvites({
    invites: [
      ...(users.map((id) => ({ type: 'User', id })) as DehydratedUser[]),
      ...(channels.map((id) => ({ type: 'Channel', id })) as DehydratedChannel[]),
      ...(emails.map((email) => ({ type: 'Email', email })) as DehydratedEmail[]),
    ],
    callback: setRecipients,
  })

  const saveConfiguration = () => {
    onConfirm({
      ...dehydrateInvites(recipients),
      permission,
      html_message: htmlMessage,
    })
    onClose()
  }

  return (
    <Modal.Root onPressOutside={onClose}>
      <Modal.Header title="Share with new people" onClose={onClose} />
      <Modal.Content>
        <div className={Styles.label}>New members</div>
        <div className={Styles.inviteesField}>
          <SharedRecipientSelector
            sourceData={sourceData()}
            recipients={recipients}
            onChange={setRecipients}
            className={Styles.inviteesInput}
            ref={(input: HTMLInputElement) => {
              if (input && !inputRef.current) {
                inputRef.current = input
                setTimeout(() => {
                  input.focus()
                }, 50)
              }
            }}
          />

          <PermissionSelect
            selectedKey={permission}
            onSelectionChange={(permission) => setPermission(permission as Permission)}
            revokable={false}
          />
        </div>

        <div className={Styles.label}>Automatic message to send</div>
        <MessageField
          value={htmlMessage}
          onChange={setHtmlMessage}
          placeholder="Add a message you can modify each time you start the automation..."
        />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" size="lg" onPress={onClose}>
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton variant="primary" size="lg" onPress={saveConfiguration}>
            Save Configuration
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export { ConfigureCreateAccessesAutomationModal }
